<template>
  <el-dialog :append-to-body="true" :visible.sync="value" :show-close="false" width="650px" custom-class="public-pool-drop-actived-dialog" @closed="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
      <h1 class="title">当前生效公客池掉落规则</h1>
      <i class="el-icon-close" style="cursor: pointer;" @click="closed"></i>
    </div>
    <div class="table-container">
      <cu-table :isLoading="isLoading" :data="list" :isShowPagination="false">
        <el-table-column label="规则内容" min-width="60%">
          <p slot-scope="scope" v-html="scope.row.content"></p>
        </el-table-column>
        <el-table-column label="提醒" min-width="40%">
          <p slot-scope="scope">{{scope.row.remind}}</p>
        </el-table-column>
      </cu-table>
    </div>
  </el-dialog>
</template>
<script>
import CuTable from '@/components/cTable';
export default{
  name: 'PublicPoolDropActived',
  components: {CuTable},
  props: {
    info: Object
  },
  data () {
    return {
      value: false,
      isLoading: false,
      list: [],
      settingCheck:{
        1:'分配后',
        2:'首次跟进后',
        3:'报备后',
        5:'带看后'
      }
    }
  },
  methods: {
    open () {
      this.value = true;
      this.isLoading = true;
      const data = [];
      const setting = this.info.auto_shift_public_setting;
      // 校验规则
      if (setting.unconfirmed_rule_active == 1) {
        let content = `分配后超过${setting.unconfirmed_time_active}${this.getUnit(setting.unconfirmed_time_unit_active)}未跟进，将掉落公客池`;
        if (setting.unconfirmed_daily_protect_start_time_active && setting.unconfirmed_daily_protect_end_time_active) {
          content += `<br/>每日：${setting.unconfirmed_daily_protect_start_time_active}至${setting.unconfirmed_daily_protect_time_cross_active == 0 ? '当日' : '次日'}${setting.unconfirmed_daily_protect_end_time_active}，掉公客池倒计时暂停`;
        }
        if (setting.unconfirmed_weekly_protect_time_active) {
          content += `<br/>每周：${this.getWeekNames(setting)}，掉公客池倒计时暂停`;
        }
        data.push({
          content: content,
          remind: `掉公客池前${setting.unconfirmed_alert_time_active}${this.getUnit(setting.unconfirmed_alert_time_unit_active)}提醒经纪人`
        })
      }
      if (setting.no_report_record_rule_active == 1) {
        data.push({
          content: `${this.settingCheck[setting.no_report_record_time_unit]}超过${setting.no_report_record_time_active}${this.getUnit(setting.no_report_record_time_unit_active)}未报备，将掉落公客池`,
          remind: `掉公客池前${setting.no_report_record_alert_time_active}${this.getUnit(setting.no_report_record_alert_time_unit_active)}提醒经纪人`
        })
      }
      if (setting.no_look_record_rule_active == 1) {
        data.push({
          content: `${this.settingCheck[setting.no_look_record_flow_type]}超过${setting.no_look_record_time_active}${this.getUnit(setting.no_look_record_time_unit_active)}未带看，将掉落公客池`,
          remind: `掉公客池前${setting.no_look_record_alert_time_active}${this.getUnit(setting.no_look_record_alert_time_unit_active)}提醒经纪人`
        })
      }
      if (setting.no_subscription_record_rule_active == 1) {
        data.push({
          content: `${this.settingCheck[setting.no_subscription_record_flow_type]}超过${setting.no_subscription_record_time_active}${this.getUnit(setting.no_subscription_record_time_unit_active)}未成交，将掉落公客池`,
          remind: `掉公客池前${setting.no_subscription_record_alert_time_active}${this.getUnit(setting.no_subscription_record_alert_time_unit_active)}提醒经纪人`
        })
      }
      if (setting.follow_interval_limit_rule_active == 1) {
        data.push({
          content: `距上次跟进时间超过${setting.follow_interval_limit_time_active}${this.getUnit(setting.follow_interval_limit_time_unit_active)}未跟进，将掉落公客池`,
          remind: `掉公客池前${setting.follow_interval_limit_alert_time_active}${this.getUnit(setting.follow_interval_limit_alert_time_unit_active)}提醒经纪人`
        })
      }

      this.list = data;
      this.isLoading = false;
    },
    getUnit (type) {
      if (type == 1) return '小时';
      if (type == 2) return '天';
      if (type == 5) return '分钟';
      return '';
    },
    getWeekNames (setting) {
      const list = ['周一', '周二', '周三', '周四', '周五', '周六', '周天'];
      if (!setting.unconfirmed_weekly_protect_time_active) return '';
      const ids = setting.unconfirmed_weekly_protect_time_active.split(',');
      const checkList = ids.map(v => {
        return list[Number(v) - 1];
      })
      return checkList.join('、');
    },
    closed () {
      this.value = false;
    }
  },
}
</script>
<style lang="less">
.public-pool-drop-actived-dialog{
  .table-container{
    height: 300px;
    display:-webkit-box;
    padding: 20px;
  }
}
</style>